import { render, staticRenderFns } from "./PodiumDisplay.vue?vue&type=template&id=1c7ca32e&scoped=true"
import script from "./PodiumDisplay.vue?vue&type=script&lang=js"
export * from "./PodiumDisplay.vue?vue&type=script&lang=js"
import style0 from "./PodiumDisplay.vue?vue&type=style&index=0&id=1c7ca32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ca32e",
  null
  
)

export default component.exports